import Button from '../Button'
import Icon from '../Icon'
import Reveal from '../Reveal'
import { Section, SectionHead } from '../Section'

/** "Entscheiden Sie sich für Casa" - the four quality markers, verbatim from
    the old Startseite. */

const QUALITIES = [
  {
    icon: 'clock',
    title: 'Erreichbarkeit',
    text: 'Ihr Anliegen wird von uns innerhalb eines Werktages bearbeitet - ein Versprechen, das sowohl Ihren Mehrwert als auch die Zufriedenheit Ihrer Mieter erhöht.',
  },
  {
    icon: 'bolt',
    title: 'Schnelligkeit',
    text: 'Durch unsere systematische und vernetzte Arbeitsweise können wir Abläufe sinnvoll priorisieren und Aufgaben schnell und präzise erledigen.',
  },
  {
    icon: 'pin',
    title: 'Regionalität',
    text: 'Dank unserer örtlichen Nähe ermöglichen wir ein Maximum an Effizienz. Kurze Wege und regelmäßige Begehungen verschaffen uns den nötigen Einblick in das Geschehen vor Ort.',
  },
  {
    icon: 'flag',
    title: 'Extrameile',
    text: 'Durch zusätzliche Dienstleistungen wie beispielsweise strategische Wertsteigerungsplanung bieten wir maßgeschneiderte Lösungen und übertreffen dabei die gängigen Branchenstandards.',
  },
]

export default function Qualities() {
  return (
    <Section>
      <SectionHead
        eyebrow="Entscheiden Sie sich für CASA"
        title="Vier Qualitätsmerkmale, die uns auszeichnen"
        lead="Wir messen uns an Kriterien, die Eigentümer im Alltag wirklich spüren - nicht an Broschürenversprechen."
      />

      <Reveal group className="grid grid--4">
        {QUALITIES.map((quality, index) => (
          <article className="card card--lift feature" key={quality.title}>
            <span className="feature__index" aria-hidden="true">
              {String(index + 1).padStart(2, '0')}
            </span>
            <span className="icon-tile">
              <Icon name={quality.icon} />
            </span>
            <h3 className="feature__title">{quality.title}</h3>
            <p>{quality.text}</p>
          </article>
        ))}
      </Reveal>

      <div className="btn-row" style={{ marginTop: 'var(--s-7)' }}>
        <Button to="/leistungen" variant="outline" icon="arrowRight">
          Mehr erfahren
        </Button>
      </div>
    </Section>
  )
}
